export default {
  contact: {
    description: 'Return a list of my contact information.',
    list: [
      {
        type: 'info',
        label: 'Email:',
        content: '`blockClothSword@Gmail.com`'
      },
      {
        type: 'info',
        label: 'Github:',
        content: '`https://github.com/blockcloth`'
      }
    ]
  }
}
